import { useMemo } from 'react';

import { IResponse, useDataProvider } from '@work4all/data';

import { InboundInvoice } from '@work4all/models/lib/Classes/InboundInvoice.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

interface UsePaymentMaskDataProps {
  id: string | number;
  entity: Entities.inboundInvoice;
}

export const usePaymentMaskData = ({ id, entity }: UsePaymentMaskDataProps) => {
  const requestData = useMemo<DataRequest>(() => {
    return {
      entity,
      data: {
        id: null,
        note: null,
        date: null,
        dueDate: null,
        supplier: {
          id: null,
          number: null,
          name: null,
          street: null,
          postalCode: null,
          city: null,
        },
        sum: null,
        currency: {
          id: null,
          name: null,
        },
        course: null,
        payments: [
          {
            id: null,
            bookingDate: null,
            datevDate: null,
            account: null,
            ledgerAccountNumber: null,
            text: null,
            user: { id: null, displayName: null },
          },
        ],
      } as InboundInvoice,
      filter: [{ id: { $eq: id } }],
    };
  }, [id, entity]);

  const response = useDataProvider(requestData);
  const data = prepareData(response, entity);

  return useMemo(() => data, [data]);
};

const prepareData = (response: IResponse, entity: Entities) => {
  const data = response.data[0] ?? {};

  switch (entity) {
    case Entities.inboundInvoice:
      return data as InboundInvoice;
  }
};
